import React, { Component } from 'react';
import Header from "../../Header/Header";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';
import './Spending.css'
import Popover from 'material-ui/Popover';
import { TextField, SelectField, MenuItem, RaisedButton } from 'material-ui';
import '../List/List.css';
import DatePicker from 'material-ui/DatePicker';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { getYearData } from '../Add/AddExports/getYearData';
import closeFilters from '../../../Assets/Images/close-filters.svg';
import '../Add/AddRequests.css';
import Translate from 'translate-components';
import { reactTranslateChangeLanguage } from 'translate-components';
import RefreshIndicator from 'material-ui/RefreshIndicator';


const loginInputStyle = {
    color: '#55aef6',
    borderColor: '#55aef6'
};
const muiTheme = getMuiTheme({
    fontFamily: 'Open Sans',
    datePicker: {
        headerColor: '#90CAF9',
        selectColor: '#90CAF9',
        color: '#90CAF9',
    },
    flatButton: {
        primaryTextColor: '#90CAF9',
    },
});
const style = {
    refresh: {
        display: 'inline-block',
        position: 'relative',
    },
};


class Spending extends Component {
    constructor(props) {
        super(props);

        // Date ranged fields.
        const minDateSpending = new Date();
        const maxDateSpending = new Date();
        minDateSpending.setFullYear(minDateSpending.getFullYear());
        minDateSpending.setMonth(minDateSpending.getMonth() - 2);
        maxDateSpending.setFullYear(maxDateSpending.getFullYear());

        this.state = {
            tableDatas: [{}],
            sOpen: false,
            page: 0,
            size: 50,
            disableNextButton: false,
            loading: false,
            selectedServiceIDs: '',
            selectedOutletNames: '',
            selectedCitys: '',
            selectedSparePart: '',
            selectedRegion: '',
            spareParts: [],
            selectedProductionYear: '',
            selectedAddress: '',
            selectedSerialNumbers: '',
            selectedProducers: '',
            selectedInventoryNumbers: '',
            selectedOldInventoryNumbers: '',
            selectedModel: '',
            minDateSpending: minDateSpending,
            maxDateSpending: maxDateSpending,
            minDateSpendingSet: false,
        };

        this.handleServiceIDs = this.handleServiceIDs.bind(this);
        this.handleOutletNames = this.handleOutletNames.bind(this);
        this.handleFilterSpending = this.handleFilterSpending.bind(this);
        this.handleCityChanges = this.handleCityChanges.bind(this);
        this.handleChangeRegion = this.handleChangeRegion.bind(this);
        this.handleAddress = this.handleAddress.bind(this);
        this.handleModelChange = this.handleModelChange.bind(this);
        this.handleSparePart = this.handleSparePart.bind(this);
        this.handleSerialNumbers = this.handleSerialNumbers.bind(this);
        this.handleInventoryNumbers = this.handleInventoryNumbers.bind(this);
        this.handleOldInventoryNumbers = this.handleOldInventoryNumbers.bind(this);
        this.pageIncrements = this.pageIncrements.bind(this);
        this.handleSelectedProducer = this.handleSelectedProducer.bind(this);
        this.handleCloseFilters = this.handleCloseFilters.bind(this);
        this.handleChangeMinDate = this.handleChangeMinDate.bind(this);
        this.handleChangeMaxDate = this.handleChangeMaxDate.bind(this);
        this.setLangEn = this.setLangEn.bind(this);
        this.setLangSr = this.setLangSr.bind(this);

    }


    setLangEn() {
        reactTranslateChangeLanguage('en');
    }

    setLangSr() {
        reactTranslateChangeLanguage('sr');
    }

    handleCloseFilters = (event) => {
        event.preventDefault();
        this.setState({
            sOpen: false,
            anchorEl: event.currentTarget,
        });
    };


    handleClicks = (event) => {


        setTimeout(() => {
            if (localStorage.getItem('selectedLang') === 'en') {
                this.setLangEn();
            }
        }, 50);

        setTimeout(() => {

            if (localStorage.getItem('selectedLang') === 'sr') {
                this.setLangSr();
            }
        }, 50);

        event.preventDefault();
        this.setState({
            sOpen: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            sOpen: false,
        });
    };



    handleModelChange = (event, index, Model) => this.setState({ selectedModel: Model });
    handleChangeRegion = (event, index, region) => this.setState({ selectedRegion: region });
    handleSelectedProducer = (event, index, Producer) => this.setState({ selectedProducers: Producer });

    handleOutletNames = (event) => {
        this.setState({
            selectedOutletNames: event.target.value,
        })
    };

    handleCityChanges = (event) => {
        this.setState({
            selectedCitys: event.target.value,
        })
    };

    handleServiceIDs = (event) => {
        this.setState({
            selectedServiceIDs: event.target.value,
        });
    };

    handleAddress = (event) => {
        this.setState({
            selectedAddress: event.target.value,
        })
    };

    handleSparePart = (event, index, SparePart) => this.setState({ selectedSparePart: SparePart });
    handleSerialNumbers = (event) => {
        this.setState({
            selectedSerialNumbers: event.target.value,
        })
    };

    handleInventoryNumbers = (event) => {
        this.setState({
            selectedInventoryNumbers: event.target.value,
        })
    };

    handleOldInventoryNumbers = (event) => {
        this.setState({
            selectedOldInventoryNumbers: event.target.value,
        })
    };

    componentDidMount() {
        const models = [];
        const regions = [];
        const statuses = [];
        const producers = [];
        const type = [];
        const serviceAction = [];
        const spareParts = [];
        const userToken = localStorage.getItem('userToken');
        fetch(`${process.env.REACT_APP_API_HOST}webportal/filter_catalog/materials_list`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-AUTH-TOKEN': userToken
            },
        }).then(response => response.json())
            .then(response => {
                spareParts.push(response.spare_parts);
                models.push(response.models);
                regions.push(response.regions);
                type.push(response.types);
                producers.push(response.producers);
                statuses.push(response.statuses);
                serviceAction.push(response.service_actions);

                this.setState({ regions: regions });
                this.setState({ models: models });
                this.setState({ type: type });
                this.setState({ spareParts: spareParts });
                this.setState({ producers: producers });
                this.setState({ statuses: statuses });
                this.setState({ serviceActions: serviceAction });
            });

        this.handleSpendingData();

        document.title = "Potrošnja materijala | Cool Beer";

        if (localStorage.getItem('selectedLang') === 'en') {
            this.setLangEn();
        }

        if (localStorage.getItem('selectedLang') === 'sr') {
            this.setLangSr();
        }

        let selectedFiltersWrapper = document.getElementsByClassName('-filters')[0];
        let selectedFilters = selectedFiltersWrapper.getElementsByTagName('input');

        for (let i = 0; i < selectedFilters.length; i++) {
            selectedFilters[i].addEventListener("keyup", function () {
                document.getElementById('table-load-wrap').scrollTop = 0;

            })
        }
    }

    componentWillUpdate() {

        setTimeout(() => {

            if (localStorage.getItem('selectedLang') === 'en') {
                this.setLangEn();
            }

            if (localStorage.getItem('selectedLang') === 'sr') {
                this.setLangSr();
            }

        }, 0)
    }

    resetFilters() {
        // Added by Predrag Zlokolica instead of the code:
        //this.setState({
        //  selectedAddress: '',
        //  selectedCitys: '',
        //  "selectedInventoryNumbers": '',
        //  selectedModel: '',
        //  selectedOldInventoryNumbers: "",
        //  selectedOutletNames: '',
        //  selectedProducers: '',
        //  selectedProductionYear: '',
        //  selectedRegion: '',
        //  selectedSerialNumbers: '',
        //  selectedServiceIDs: '',
        //  selectedSparePart: ''
        //})

        // @TODO Find a better way to reset filters and remove this.
        window.location.reload();
    }



    handleSpendingData() {
        const userToken = localStorage.getItem('userToken');
        this.setState({
            loading: true
        })
        fetch(`${process.env.REACT_APP_API_HOST}webportal/material_consumption/50/0`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-AUTH-TOKEN': userToken,
                'Accept': 'application/json'
            },
        }).then(response => response.json())
            .then(response => {
                this.setState({ tableDatas: response, loading: false });
            });
    }


    checkminDateSpendingFromQuery() {

        if (this.state.minDateSpendingSet === true) {

            let parameters = '';

            const dateCheck = new Date();
            dateCheck.setFullYear(dateCheck.getFullYear());
            dateCheck.setMonth(dateCheck.getMonth())

            if (this.state.minDateSpending !== dateCheck) {
                parameters += '&completed_date_from=' + this.formatDate(this.state.minDateSpending);
            };


            if (parameters !== '') {
                parameters = '&' + parameters;
            }

            return parameters;
        }

        else {
            return '';
        }
    }


    handleFilterSpending() {

        const userToken = localStorage.getItem('userToken');
        this.setState({ loading: true })
        fetch(`${process.env.REACT_APP_API_HOST}webportal/material_consumption/${this.state.size}/0${this.checkStatesValuesSpendingMaterials()}${this.checkminDateSpendingFromQuery()}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Access-Control-Allow-Origin': '*',
                Accept: 'application/json',
                'X-AUTH-TOKEN': userToken,
                'Content-Type': 'application/json',
            },

        }).then(response => response.json())
            .then(response => {
                this.setState({ tableDatas: response });
                this.setState({ sOpen: false, loading: false });
            });
    }

    handleChangeMinDate = (event, date) => {
        this.setState({
            minDateSpending: date,
        });
    };

    handleChangeMaxDate = (event, date) => {
        this.setState({
            maxDateSpending: date,
        })
    }

    scrollTableHeightSpendingHandler = () => {
        let selectHeaderOne = document.getElementsByClassName('-header')[0];
        let selectedHeaderFilters = document.getElementsByClassName('-filters')[0];
        let selectedeaderGroups = document.getElementsByClassName('-headerGroups')[0];
        let scrollHeight = document.getElementById('table-load-wrap').scrollTop;

        selectHeaderOne.style.top = scrollHeight + "px";
        selectedHeaderFilters.style.top = scrollHeight + "px";
        selectedeaderGroups.style.top = scrollHeight + "px";

    }

    formatDate(date) {
        return date.getFullYear() + "-" + ((date.getMonth() + 1)) + "-" + ("0" + date.getDate());
    }

    checkStatesValuesSpendingMaterials() {
        let parameters = '';

        const dateCheck = new Date();
        dateCheck.setFullYear(dateCheck.getFullYear());
        dateCheck.setMonth(dateCheck.getMonth())

        if (this.state.selectedRegion !== '') {
            parameters += '&region=' + this.state.selectedRegion;
        };

        if (this.state.selectedProducers !== '') {
            parameters += '&manufacturer=' + this.state.selectedProducers;
        };

        if (this.state.selectedSerialNumbers !== '') {
            parameters += '&serial_number=' + this.state.selectedSerialNumbers;
        };


        if (this.state.selectedProductionYear !== '') {
            parameters += '&production_year=' + this.state.selectedProductionYear;
        };

        if (this.state.selectedModel !== '') {
            parameters += '&equipment_model=' + this.state.selectedModel;
        };

        if (this.state.selectedAddress !== '') {
            parameters += '&address=' + this.state.selectedAddress;
        };

        if (this.state.selectedOldInventoryNumbers !== '') {
            parameters += '&old_inventory_no=' + this.state.selectedOldInventoryNumbers;
        };

        if (this.state.selectedInventoryNumbers !== '') {
            parameters += '&inventory_number=' + this.state.selectedInventoryNumbers;
        };

        if (this.state.selectedOutletNames !== '') {
            parameters += '&outlet=' + this.state.selectedOutletNames;
        };

        if (this.state.selectedCitys !== '') {
            parameters += '&city=' + this.state.selectedCitys;
        };

        if (this.state.selectedServiceIDs !== '') {
            parameters += '&service_id=' + this.state.selectedServiceIDs;
        };

        if (this.state.selectedSparePart !== '') {
            parameters += '&spare_part=' + this.state.selectedSparePart;
        }

        if (this.state.maxDateSpending !== dateCheck) {
            parameters += '&completed_date_to=' + this.formatDate(this.state.maxDateSpending);
        };

        if (parameters !== '') {
            parameters = '?' + parameters;
        }

        return parameters;
    }


    async pageIncrements() {

        await this.setState({
            page: this.state.page + 1,
            loading: true,
        });
        const userToken = localStorage.getItem('userToken');


        fetch(`${process.env.REACT_APP_API_HOST}webportal/material_consumption/${this.state.size}/${this.state.page}${this.checkStatesValuesSpendingMaterials()}${this.checkminDateSpendingFromQuery()}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Access-Control-Allow-Origin': '*',
                Accept: 'application/json',
                'X-AUTH-TOKEN': userToken,
                'Content-Type': 'application/json',
            },

        }).then(response => response.json())
            .then(response => {
                if (typeof response === 'undefined' || response.length === 0) {
                    this.setState({ disableNextButton: true })
                }

                this.setState({
                    tableDatas: this.state.tableDatas.concat(response),
                    loading: false
                });
            });
    }



    render() {
        const { tableDatas } = this.state;

        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div>
                    <Header {...this.props} />
                    <RaisedButton
                        label={<Translate>Primenite filtere</Translate>}
                        className="filter-submit"
                        onClick={this.handleClicks}
                        style={{
                            display: "inline-block",
                            marginLeft: 15,
                            marginTop: 15,
                            marginBottom: 15,
                        }}
                    />
                    <Popover
                        open={this.state.sOpen}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
                        targetOrigin={{ horizontal: 'middle', vertical: 'top' }}
                        onRequestClose={this.handleRequestClose}
                        className="popover-style"
                        style={{ minWidth: "100vw" }}
                    >
                        <nav className="wraper-mat">
                            <img className="close-filters" alt="close filters" onClick={this.handleCloseFilters} src={closeFilters} />
                            <div >
                                <DatePicker
                                    onChange={this.handleChangeMinDate}
                                    floatingLabelFixed={true}
                                    className="form-item form-item--dp-od"
                                    autoOk={this.state.autoOk}
                                    floatingLabelText={<Translate>Datum prijave od:</Translate>}
                                    onClick={async () => {
                                        await this.setState({
                                            minDateSpendingSet: true,
                                        })
                                    }}
                                    textFieldStyle={{ marginRight: 10 }}
                                    dialogContainerStyle={{ zIndex: 11000 }}
                                    style={{ display: "inline-block" }}
                                    disableYearSelection={this.state.disableYearSelection}
                                />
                                <DatePicker
                                    className="form-item form-item--dp-do"
                                    onChange={this.handleChangeMaxDate}
                                    floatingLabelFixed={true}
                                    autoOk={this.state.autoOk}
                                    textFieldStyle={{ marginRight: 10 }}
                                    dialogContainerStyle={{ zIndex: 11000, headerColor: "orange" }}
                                    floatingLabelText={<Translate>Datum prijave do:</Translate>}
                                    disableYearSelection={this.state.disableYearSelection}
                                />
                            </div>
                            <TextField
                                floatingLabelText={<Translate>ID zahteva:</Translate>}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                floatingLabelFixed={true}
                                onChange={this.handleServiceIDs}
                                value={this.state.selectedServiceIDs}
                                style={{ marginRight: 10 }}
                                className="form-item form-item--id"
                            />
                            <SelectField
                                floatingLabelText={"Region:"}
                                floatingLabelFixed={true}
                                className="form-item form-item--region"
                                onChange={this.handleChangeRegion}
                                value={this.state.selectedRegion}
                            >
                                {
                                    this.state.regions && this.state.regions.map(region => {
                                        return Object.entries(region).map(([key, region]) => {
                                            return <MenuItem key={key} value={region} primaryText={region} />
                                        })
                                    })
                                }
                            </SelectField>
                            <TextField
                                floatingLabelFixed={true}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                className="form-item form-item--lokal"
                                onChange={this.handleOutletNames}
                                value={this.state.selectedOutletNames}
                                floatingLabelText={<Translate>Naziv lokala:</Translate>}
                                style={{ marginRight: 10 }}
                            />
                            <TextField
                                floatingLabelFixed={true}
                                floatingLabelText={<Translate>Adresa:</Translate>}
                                onChange={this.handleAddress}
                                value={this.state.selectedAddress}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                style={{ marginRight: 10 }}
                                className="form-item form-item--adresa"
                            />
                            <TextField
                                floatingLabelFixed={true}
                                floatingLabelText={<Translate>Grad:</Translate>}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                onChange={this.handleCityChanges}
                                className="form-item form-item--grad"
                                style={{ marginRight: 10 }}
                            />
                            <SelectField
                                className="form-item form-item--proizvodjac"
                                floatingLabelFixed={true}
                                floatingLabelText={<Translate>Model:</Translate>}
                                autoWidth={true}
                                value={this.state.selectedProducers}
                                onChange={this.handleSelectedProducer}
                                maxHeight={300}
                            >
                                {
                                    this.state.producers && this.state.producers.map(producer => {
                                        return Object.entries(producer).map(([key, producer]) => {
                                            return <MenuItem key={key} value={producer} primaryText={producer} />
                                        })
                                    })
                                }
                            </SelectField>
                            <SelectField
                                className="form-item form-item--proizvodjac"
                                floatingLabelFixed={true}
                                onChange={this.handleSparePart}
                                value={this.state.selectedSparePart}
                                floatingLabelText={<Translate>Rezervni deo:</Translate>}
                                autoWidth={true}
                                maxHeight={300}
                            >
                                {
                                    this.state.spareParts && this.state.spareParts.map(SparePart => {
                                        return Object.entries(SparePart).map(([key, SparePart]) => {
                                            return <MenuItem key={key} value={SparePart} primaryText={SparePart} />
                                        })
                                    })
                                }
                            </SelectField>
                            <TextField
                                floatingLabelFixed={true}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                value={this.state.selectedSerialNumbers}
                                floatingLabelText={<Translate>Serijski broj:</Translate>}
                                onChange={this.handleSerialNumbers}
                                style={{ marginRight: 10 }}
                                className="form-item form-item--serijski"
                            />
                            <TextField
                                floatingLabelFixed={true}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                value={this.state.selectedInventoryNumbers}
                                floatingLabelText={<Translate>Inventarni broj:</Translate>}
                                onChange={this.handleInventoryNumbers}
                                className="form-item form-item--inventarni"
                                style={{ marginRight: 10 }}
                            />
                            <TextField
                                floatingLabelFixed={true}
                                floatingLabelFocusStyle={loginInputStyle}
                                underlineFocusStyle={loginInputStyle}
                                value={this.state.selectedOldInventoryNumbers}
                                floatingLabelText={<Translate>Stari inventarni broj:</Translate>}
                                onChange={this.handleOldInventoryNumbers}
                                className="form-item form-item--inventarni"
                                style={{ marginRight: 10 }}
                            />
                            <SelectField
                                floatingLabelText={<Translate>Proizvođač:</Translate>}
                                autoWidth={true}
                                maxHeight={400}
                                floatingLabelFixed={true}
                                onChange={this.handleModelChange}
                                value={this.state.selectedModel}
                                className="form-item form-item--model"
                            >
                                {
                                    this.state.models && this.state.models.map(model => {
                                        return Object.entries(model).map(([key, Model]) => {
                                            return <MenuItem key={key} value={Model} primaryText={Model} />
                                        })
                                    })
                                }
                            </SelectField>
                            <SelectField
                                autoWidth={true}
                                floatingLabelFixed={true}
                                floatingLabelText={<Translate>Godina proizvodnje</Translate>}
                                floatingLabelFocusStyle={loginInputStyle}
                                value={this.state.selectedProductionYear}
                                maxHeight={300}
                                underlineFocusStyle={loginInputStyle}
                                onChange={(event, index, value) => this.setState({
                                    selectedProductionYear: value
                                })}
                                className="form-item form-item--godinas"
                            >
                                {
                                    getYearData().map((year) => {
                                        return (
                                            <MenuItem key={year.id} value={year.id} primaryText={year.value} />
                                        );
                                    })
                                }
                            </SelectField>
                        </nav>
                        <div className="filter-btn-wrap">
                            <RaisedButton
                                label={<Translate>Filtriraj</Translate>}
                                onClick={this.handleFilterSpending}
                                style={{
                                    display: "inline-block",
                                    marginTop: 25,
                                    marginBottom: 10,
                                    marginRight: 20,
                                    maxWidth: 100
                                }}
                            />
                            <RaisedButton
                                label={<Translate>Resetuj</Translate>}
                                style={{
                                    display: "inline-block",
                                    marginTop: 25,
                                    marginBottom: 10,
                                    maxWidth: 100
                                }}
                                onClick={this.resetFilters.bind(this)}
                            />
                        </div>
                    </Popover>
                    {this.state.loading ?
                        <div className="loader-indicator-spending">
                            <RefreshIndicator
                                size={40}
                                left={10}
                                loadingColor="#90caf9"
                                top={20}
                                status="loading"
                                style={style.refresh}
                            />
                        </div>
                        : null}
                    {/*Table*/}

                    <div id="table-load-wrap" className="table-load-wrap"
                        onScroll={this.scrollTableHeightSpendingHandler}
                    >
                        <ReactTable
                            data={tableDatas}
                            filterable
                            pageSize={tableDatas.length}

                            noDataText="Nema rezultata."
                            showPagination={false}
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.service_id]) === filter.value}
                            columns={[
                                {
                                    columns: [
                                        {
                                            Header: <Translate>ID zahteva</Translate>,
                                            accessor: 'service_id',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["service_id"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Naziv lokala</Translate>,
                                            accessor: 'outlet_name',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["outlet_name"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Adresa lokala</Translate>,
                                            accessor: 'address',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["address"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Grad</Translate>,
                                            accessor: 'outlet_city',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["outlet_city"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Datum završetka</Translate>,
                                            accessor: 'date_exit',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["date_exit"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Model</Translate>,
                                            accessor: 'eq_model',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["eq_model"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Proizvođač</Translate>,
                                            accessor: 'eq_producer',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["eq_producer"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Serijski broj</Translate>,
                                            accessor: 'serial_no',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["serial_no"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Inventarni broj</Translate>,
                                            accessor: 'inventory_no',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["inventory_no"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Stari inventarni broj</Translate>,
                                            accessor: 'old_inventory_no',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["old_inventory_no"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Godina proizvodnje</Translate>,
                                            accessor: 'Year',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Year"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Kvar</Translate>,
                                            accessor: 'malfunction_reported',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["malfunction_reported"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Vrsta usluge</Translate>,
                                            accessor: 'Action',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Action"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Količina</Translate>,
                                            accessor: 'item_qty',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["item_qty"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Rezervni deo</Translate>,
                                            accessor: 'Item',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["Item"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                        {
                                            Header: <Translate>Šifra rezervnog dela</Translate>,
                                            accessor: 'item_code',
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["item_code"] }),
                                            filterAll: true,
                                            width: 145,
                                        },
                                    ],
                                }
                            ]}
                            className="-striped -highlight"
                        />
                        <RaisedButton
                            label={<Translate>Prikaži više</Translate>}
                            onClick={this.pageIncrements}
                            style={{ display: "block", margin: 20 }}
                            className="load-more-items"
                            disabled={this.state.disableNextButton}
                        />
                    </div>
                </div>
            </MuiThemeProvider >
        );
    }
}


export default Spending;



// WEBPACK FOOTER //
// ./src/Components/Requests/Spending/Spending.jsx